import { connect } from 'react-redux'
import CompetitionDirectory from './CompetitionDirectory'

export const Competitions = CompetitionDirectory
export default connect(({ session: { userDetails } = {} }) => ({ userDetails }))(CompetitionDirectory)
